import useUiuxStore from "src/store/useUiuxStore";
import { showWarning } from "src/utils/toast/toastUtil";
import { validateItemAccount, isDuplicateChildItemcd, restoreOriginalValues } from "../Util_MST1020_R01";
import { MST1020_R01_BomDto } from "../Dto_MST1020_R01";

interface UseBomModalProps {
	updateMST1020_R01Bom: (index: number, data: MST1020_R01_BomDto) => void;
	gridRef: any;
	MST1020_R01BomList: MST1020_R01_BomDto[];
}

export function useBomModal({ updateMST1020_R01Bom, gridRef, MST1020_R01BomList }: UseBomModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	// 모달 닫힘 콜백
	const handlePopupClose = () => {
		if (gridRef.current?.api) {
			gridRef.current.api.stopEditing();
		}
	};

	// 코드검색 모달 열기 및 처리
	const settingCodeSearchModalProps = (
		category: string,
		search: string,
		isInfo: boolean,
		handleFoucsId: string,
		originalData: MST1020_R01_BomDto,
		valueIndex: number,
		extraFilter?: { itemAccount?: string }
	) => {
		if (originalData.bomUseyn === 'N') return;

		// 비우기/취소 공통 핸들러 (CodeSearchModal 취소도 onClear 호출)
		const handleClear = () => {
			updateMST1020_R01Bom(valueIndex, {
				...originalData,
				childItemcd: '',
				childItemnm: '',
				itemSpec: '',
				locationCd: '',
				locationNm: '',
				childItemUnit: '',
				bomUpdateNo: originalData.bomUpdateNo || '1',
				isModified: originalData.inserted ? false : true,
			});
			handlePopupClose();
		};

		setCodeSearchModalProps({
			category,
			search,
			formName: 'MST1020_R01_BOM',
			isInfo,
			handleFoucsId,
			onClear: handleClear,
			onConfirm: (data: any) => {
				updateMST1020_R01Bom(valueIndex, {
					...originalData,
					childItemcd: data.itemCd || '',
					childItemnm: data.itemNm || '',
					itemSpec: data.itemSpec || '',
					locationCd: data.locationCd || '',
					locationNm: data.locationNm || '',
					childItemUnit: data.itemUnit || '',
					bomUpdateNo: originalData.bomUpdateNo || '1',
					isModified: originalData.inserted ? false : true,
				});
				if (data.itemAccount && !validateItemAccount(data.itemAccount)) {
					showWarning(
						`선택한 품목(${data.itemNm})은 BOM 등록이 불가능한 계정입니다.\n허용 품목 계정: 재공품, 원자재, 부자재`,
						5000
					);
					restoreOriginalValues(valueIndex, originalData, updateMST1020_R01Bom, gridRef);
					return;
				}
				const duplicateCount = isDuplicateChildItemcd(MST1020_R01BomList, data.itemCd, valueIndex) ? 1 : 0;
				if (duplicateCount > 0) {
					showWarning(`경고: 자품목코드 '${data.itemNm}'가 이미 존재합니다. (${duplicateCount + 1}개)`, 3000);
					restoreOriginalValues(valueIndex, originalData, updateMST1020_R01Bom, gridRef);
					return;
				}
				const currentRow = MST1020_R01BomList.find(item => item.valueIndex === valueIndex);
				if (currentRow && data) {
					updateMST1020_R01Bom(valueIndex, {
						...currentRow,
						childItemcd: data.itemCd || '',
						childItemnm: data.itemNm || '',
						itemSpec: data.itemSpec || '',
						locationCd: data.locationCd || '',
						locationNm: data.locationNm || '',
						childItemUnit: data.itemUnit || '',
						bomUpdateNo: currentRow.bomUpdateNo || '1',
						isModified: true
					});
				}
				setTimeout(() => {
					const api = gridRef.current?.api;
					if (!api) return;
					let targetRowIndex = -1;
					api.forEachNode((node: any) => {
						if (node.data && node.data.valueIndex === valueIndex && node.rowIndex !== null) {
							targetRowIndex = node.rowIndex;
						}
					});
					if (targetRowIndex !== -1) {
						api.startEditingCell({
							rowIndex: targetRowIndex,
							colKey: 'prntItemQty'
						});
					}
				}, 0);
			},
			wrapperOption: {
				size: 'md',
				width: 50,
				overlay: true
			},
			extraFilter
		});
	};

	return { settingCodeSearchModalProps, handlePopupClose };
}
